<template>
  <top topindex="1"></top>

  <div class="web_banner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div @click="$tolinkurl(item.linkUrl)" class="swiper-slide" v-for="(item, index) in bannerList"
          v-bind:key="index" v-if="bannerList.length > 0">
          <figure class="web" :style="{
            backgroundImage: 'url(' + $bindImg(item.coverImage) + ')',
          }"></figure>

          <figure class="wap" :style="{
            backgroundImage: 'url(' + $bindImg(item.phoneImage) + ')',
          }"></figure>
        </div>
      </div>

      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>

  <div class="indexPart1 wow fadeInUp">
    <div class="left_text">
      <div class="en" style="color: #698bcf;">COMPANY HIGHLIGHTS</div>
      <h3>公司风采</h3>
      <div class="slogan">
        闪耀时刻，活动亮点精彩纷呈
      </div>
      <aside v-html="formgskg.content"></aside>
    </div>
    <div class="right_swiper" @contextmenu="disableRightClick">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in gsfcList">
            <video id="couVid" :src="$bindImg(item.fileUrl)" controls controlsList="nodownload"></video>
            <div class="video-title">{{ item.title }}</div>
          </div>
        </div>
      </div>

      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>

  <div class="indexPart2 wow fadeInUp">
    <div class="index_tit">
      <div class="en">BUSINESS LAYOUT</div>
      <div class="cn">业务布局</div>
      <div class="slogan">
        为工程建设领域从业者提供全过程知识供应服务
      </div>
    </div>

    <div class="flex_box business-swiper">
      <div class="swiper-container business-container">
        <div class="swiper-wrapper business-wrapper">
          <div class="swiper-slide item" v-for="item in ywbjList">
            <img :src="$bindImg(item.coverImage)" alt="" class="icon" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.rank }}</p>
            <ul v-html="item.info1"></ul>
            <div class="btn" @click="item.linkUrl ? $tolinkurl(item.linkUrl) : showNotOpenMessage()">进入平台</div>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>

        <!-- Pagination if needed -->
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>

  <div class="indexPart3 wow fadeInUp">
    <div class="index_tit">
      <div class="en">NEWS INFORMATION</div>
      <div class="cn">新闻资讯</div>
      <div class="slogan">捕捉行业热点，洞悉权威资讯</div>
    </div>

    <div class="new_swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in newsList" @click="$pushTo(`/web/new-deta?id=${item.id}`)">
            <div class="type">{{ item.categoryTitle }}</div>
            <div class="title">
              <p class="test">{{ item.title }}</p>
            </div>
            <div class="con dot3">
              <p class="con-test">{{ item.info1 }}</p>
            </div>
            <div class="bot">
              <div class="date">
                <p>{{ item.CreateTimeString1 }}</p>
                <b>{{ item.CreateTimeString2 }}</b>
              </div>
              <div class="btn"></div>
            </div>

          </div>
        </div>

        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>

      <div class="more_btn" @click="$pushTo(`/web/news`)">更多资讯</div>
    </div>
  </div>

  <div class="indexPart4 wow fadeInUp">
    <div class="left">
      <div class="title">
        <div class="en">ABOUT US</div>
        <div class="cn" style="font-weight: bold;">公司概况</div>
        <div class="slogan">探索工程领域教育发展新格局</div>
      </div>
      <div class="slogan">{{ formgskgindex.title }}</div>
      <div class="con" v-html="formgskgindex.content"></div>

      <div class="more_btn" @click="$pushTo(`/web/about-profile`)">
        了解更多
      </div>
    </div>
    <div class="right">
      <div class="num_box">
        <div class="item" v-for="item in statisticList">
          <p v-html="item.title"></p>
          <span v-html="item.rank"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="indexPart5 wow fadeInUp" :style="{ 'background-image': 'url(' + $bindImg(form.coverImage) + ')' }">
    <!-- <div class="map_us">
      <img :src="$bindImg(form.coverImage)" alt="" />
    </div> -->
    <div class="form_box">
      <div class="tit">
        <div class="en">CONTACT US</div>
        <div class="cn">联系我们</div>
        <div class="slogan">多类合作业务，为您提供完美解决方案</div>
      </div>

      <div class="input_box">
        <span>*</span>
        <select v-model="liuyanModel.category">
          <option disabled value="0" selected>合作方向</option>
          <option :value="item.id" v-for="item in hzfxList">
            {{ item.title }}
          </option>
        </select>
      </div>
      <div class="input_box">
        <span>*</span>
        <input type="text" placeholder="单位/学校" v-model="liuyanModel.title" />
      </div>
      <div class="input_box">
        <span>*</span>
        <input type="text" placeholder="联系人姓名" v-model="liuyanModel.rank" />
      </div>
      <div class="input_box">
        <span>*</span>
        <input type="text" placeholder="联系电话" v-model="liuyanModel.label" />
      </div>
      <div class="input_box">
        <input type="text" placeholder="合作需求" v-model="liuyanModel.info1" />
      </div>
      <el-button class="saveBtn" :loading="submitting" @click="tijiaoLiuyan">
        确认提交
      </el-button>
    </div>
  </div>

  <div class="indexPart6">
    <div class="left">
      <img src="@/assets/uploadfiles/web/bg4.png" alt="" @click="$pushTo(`/web/about-recruit`)" />
    </div>
    <div class="branch_box">
      <div class="t1">
        分支机构<img src="@/assets/uploadfiles/web/arrow2.png" alt="" />
      </div>

      <ul>
        <li v-for="item in fzjgList" @click="$tolinkurl(item.linkUrl)">
          {{ item.title }}
        </li>
      </ul>

      <div class="more_btn" @click="$pushTo(`/web/branch`)">
        更多
        <img src="@/assets/uploadfiles/web/arrow4.png" alt="" class="icon" />
      </div>
    </div>
  </div>

  <bottom></bottom>
</template>

<script>
import top from "@/components/Web/top";
import bottom from "@/components/Web/bottom";
import Swiper from "swiper";
import { GetItemById, GetPage, Add } from "@/api/webSite/content";
import { WOW } from "wowjs";
import * as channelApi from "@/api/channel";

export default {
  metaInfo() {
		return {
			title: this.seoTitle,
			meta: [{                 // set keyWords
				name: 'keyWords',
				content: this.seoKeyWords
			},
			{                 // set Description
				name: 'Description',
				content: this.seoDescription
			}],
		};
	},
  components: {
    Swiper,
    top,
    bottom,
  },
  data() {
    return {
      seoTitle: '北京兰麦科技有限公司',
			seoKeyWords: '北京兰麦科技有限公司',
			seoDescription: '北京兰麦科技有限公司',
      submitting: false,

      //首页banner
      bannerList: [],
      newList: [],
      //公司概况
      formgskg: {},
      //公司风采轮播
      gsfcList: [],
      //业务布局
      ywbjList: [],
      //新闻
      newsList: [],
      //首页公司概况
      formgskgindex: {},
      //分支机构
      fzjgList: [],
      //数字统计
      statisticList: [],
      form: [],

      //留言
      liuyanModel: {
        category: 0,
        columnId: 25,
        title: "",
        rank: "",
        label: "",
        info1: "",
      },
      //合作方向列表
      hzfxList: {},
    };
  },
  mounted() {
    let _this = this;
    new WOW().init();
    this.newSwiper();
    this.loadInfo(); //公司概况信息
    this.loadlistbanner(); //头部banner
    this.loadgsfcList(); //公司风采轮播
    this.loaywbjList(); //业务布局轮播
    this.loadlistnews(); //首页新闻
    this.loadInfoIndex(); //首页公司概况
    this.loadfzjgList(); //分支机构
    this.loadhzfxList(); //合作方向
    this.loadstatisticList();//数字统计
    this.loadForm(); //联系我们地图

    _this.$nextTick(() => {
			_this.initSeoObj();
		});
  },
  methods: {
    initSeoObj() {
			let _this = this;
			
			channelApi.GetItemById({
				id: 12,//ID 对应后台内容管理的栏目ID
			}).then((res) => {
				console.log('channelApi.GetItemById', res);
				_this.seoTitle = res.body.metaTitle;
				_this.seoKeyWords = res.body.metaKeywords;
				_this.seoDescription = res.body.metaDescription;
			}).catch((err) => {
				console.log('channelApi.GetItemById', err);
			}); // 设置页面SEO信息
		},
    showNotOpenMessage() {
      this.$errorMessage('尚未开通，请稍后再试。');
    },
    disableRightClick(event) {
      event.preventDefault();
    },
    tijiaoLiuyan() {
      var that = this;

      if (that.liuyanModel.category == 0) {
        that.$errorMessage("请选择合作方向");
        return;
      }
      if (that.liuyanModel.title == "") {
        that.$errorMessage("请填写单位/学校");
        return;
      }
      if (that.liuyanModel.rank == "") {
        that.$errorMessage("请填写联系人姓名");
        return;
      }
      if (that.liuyanModel.label == "") {
        that.$errorMessage("请填写联系电话");
        return;
      } else {
        const regCorporateTel =
          /(^([0-9]{4}-[0-9]{8})|([0-9]{3}-[0-9]{8})|([0-9]{4}-[0-9]{7})$)|(^(1[3|4|5|7|8])(\d){9}$)/;
        if (!regCorporateTel.test(this.liuyanModel.label)) {
          this.$errorMessage("联系电话格式不正确");
          return
        }
      }
      that.submitting = true;
      Add({ model: that.liuyanModel })
        .then((res) => {
          that.submitting = false;
          that.$successMessage("提交成功");
          that.liuyanModel.category = 0;
          that.liuyanModel.title = "";
          that.liuyanModel.rank = "";
          that.liuyanModel.label = "";
          that.liuyanModel.info1 = "";
        })
        .catch((err) => {
          that.submitting = false;
          console.log("Add", err);
        });
    },
    //合作方向
    loadhzfxList() {
      var that = this;
      var filter = { columnId: 26 };
      GetPage({
        pageIndex: 1,
        pageSize: 80,
        filter: JSON.stringify(filter),
      }).then((res) => {
        that.hzfxList = res.body.items;

        console.log("hzfxList", that.hzfxList);
      }).catch((err) => { });
    },
    //分支机构
    loadfzjgList() {
      var that = this;
      var filter = { columnId: 21 };
      GetPage({
        pageIndex: 1,
        pageSize: 3,
        filter: JSON.stringify(filter),
      })
        .then((res) => {
          that.fzjgList = res.body.items;

          console.log("fzjgList", that.fzjgList);
        })
        .catch((err) => { });
    },
    //数字统计
    loadstatisticList() {
      var that = this;
      var filter = { columnId: 31 };
      GetPage({
        pageIndex: 1,
        pageSize: 99,
        filter: JSON.stringify(filter),
      })
        .then((res) => {
          that.statisticList = res.body.items;

          console.log("statisticList", that.statisticList);
        })
        .catch((err) => { });
    },
    //首页新闻
    loadlistnews() {
      var that = this;
      var filter = { columnId: 9, isHome: true };
      GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify(filter),
      })
        .then((res) => {
          that.newsList = res.body.items;

          console.log("newsList", that.newsList);
        })
        .catch((err) => { });
    },
    //头部banner
    loadlistbanner() {
      var that = this;
      var filter = { columnId: 20 };
      GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify(filter),
      })
        .then((res) => {
          that.bannerList = res.body.items;
          that.bannerSwiper();

          console.log("bannerList", that.listNews);
        })
        .catch((err) => { });
    },
    //公司风采轮播
    loadgsfcList() {
      var that = this;
      var filter = { columnId: 23 };
      GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify(filter),
      })
        .then((res) => {
          that.gsfcList = res.body.items;
          that.videoSwiper();

          console.log("gsfcList", that.gsfcList);
        })
        .catch((err) => { });
    },
    //业务布局轮播
    loaywbjList() {
      var that = this;
      var filter = { columnId: 19 };
      GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify(filter),
      })
        .then((res) => {
          that.ywbjList = res.body.items;

          this.$nextTick(() => {
            new Swiper(".business-swiper .business-container", {
              slidesPerView: 3,
              spaceBetween: 100,
              paginationClickable: true,
              observer: true,
              observeParents: true,
              navigation: {
                nextEl: ".business-container .swiper-button-next",
                prevEl: ".business-container .swiper-button-prev",
              },
              breakpoints: {
                768: {
                  //当屏幕宽度大于等于768
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                1280: {
                  //当屏幕宽度大于等于1280
                  slidesPerView: 3,
                  spaceBetween: 100,
                },
              },
            });
          });
          console.log("ywbjList", that.ywbjList);

        })
        .catch((err) => { });
    },
    //公司概况信息
    loadInfo() {
      var that = this;
      GetItemById({
        columnId: 1,
      })
        .then((res) => {
          that.formgskg = res.body;
          that.form = res.body;
          console.log('formgskg', that.formgskg)

        })
        .catch((err) => { });
    },

    loadForm() {
      var that = this;
      GetItemById({
        columnId: 7,
      })
        .then((res) => {
          that.form = res.body;
          console.log('formgskg', that.formgskg)

        })
        .catch((err) => { });
    },
    //首页公司概况
    loadInfoIndex() {
      var that = this;
      GetItemById({
        columnId: 24,
      })
        .then((res) => {
          that.formgskgindex = res.body;
          console.log("formgskgindex", that.formgskgindex);
        })
        .catch((err) => { });
    },

    bannerSwiper() {
      this.$nextTick(() => {
        new Swiper(".web_banner .swiper-container", {
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          pagination: {
            el: ".web_banner .swiper-pagination",
            type: "fraction",
          },
          navigation: {
            nextEl: ".web_banner .swiper-button-next",
            prevEl: ".web_banner .swiper-button-prev",
          },
          paginationClickable: true,
          autoplay: true,
          loop: true,
        });
      });
    },
    videoSwiper() {
      this.$nextTick(() => {
        new Swiper(".right_swiper .swiper-container", {
          slidesPerView: 1,
          navigation: {
            nextEl: ".right_swiper .swiper-button-next",
            prevEl: ".right_swiper .swiper-button-prev",
          },
          pagination: {
            el: ".right_swiper .swiper-pagination",
          },
          loop: true,
        });
      });
    },
    newSwiper() {
      this.$nextTick(() => {
        new Swiper(".new_swiper .swiper-container", {
          slidesPerView: 1,
          paginationClickable: true,
          autoplay: 5000,
          observer: true,
          observeParents: true,
          breakpoints: {
            768: {
              //当屏幕宽度大于等于768
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1280: {
              //当屏幕宽度大于等于1280
              slidesPerView: 4,
              spaceBetween: 25,
            },
          },
        });
      });
    },
  },
};
</script>
